import { CosmosClient } from "@azure/cosmos";
import { authProvider } from '../utils/authProvider';

export class GeneralUtil {
    
    public async GetList(searchParams: any) {
        let accountInfo = await authProvider.getAccountInfo();

        let API_URL = 'https://ultimatesprodevapilx01.azurewebsites.net/api';
        let API_ENDPOINT = '/GeneralColGetList?code=DrjCu2pyzocioGVz4FIlW54MkpLL61rWs2EWaalLUAYay3O3n2IuOQ==';
        let API = API_URL + API_ENDPOINT ;

        let response = await fetch(API,
            {
                method: "post",
                headers: new Headers({
                    "Authorization": "Bearer " + accountInfo?.jwtIdToken,
                    "Content-Type": "application/json"
                }),
                body: JSON.stringify(searchParams)
            }
        );
        if (response.ok) {
            let result = await response.json();
            if (result.isSuccess) {
                return result;
            } else {
                return { errors : result.errors };
            }
        } else {
            // Error return from Azure Fucntion
            let errorResponse = await response.json();
            return { errors : 'Connection failed to API. Error:' + errorResponse.Message };
        }
    }

    public async Read(_id: string, table:string) {
        let accountInfo = await authProvider.getAccountInfo();

        let API_URL = 'https://ultimatesprodevapilx01.azurewebsites.net/api';
        let API_ENDPOINT = '/GeneralColRead?code=4921VCJfMWhXcniZhs4zaiHfv72597zvaEQk1Q35SNpMEUrGuObCQA==';
        let API_PARAM = '&id=' + _id + '&table=' + table;
        let API = API_URL + API_ENDPOINT + API_PARAM;

        let response = await fetch(API,
            {
                method: "get",
                headers: new Headers({
                    "Authorization": "Bearer " + accountInfo?.jwtIdToken,
                    "Content-Type": "application/json"
                })
            }
        );
        if (response.ok) {
            let result = await response.json();
            if (result.isSuccess) {
                return result;
            } else {
                return { errors : result.errors };
            }
        } else {
            return { errors : 'Connection failed to API' };
        }
    }

    public async Create(_doc: any) {
        let accountInfo = await authProvider.getAccountInfo();

        let API_URL = 'https://ultimatesprodevapilx01.azurewebsites.net/api';
        let API_ENDPOINT = '/GeneralColCreate?code=1hGn2L6WSp2jhFx8qovAe1/ycEG7NEDr63rrKddielAN52yFhzNNjQ==';

        let API = API_URL + API_ENDPOINT;
        let response = await fetch(API,
            {
                method: "post",
                headers: new Headers({
                    "Authorization": "Bearer " + accountInfo?.jwtIdToken,
                    "Content-Type": "application/json"
                }),
                body: JSON.stringify(_doc)
            }
        );

        if (response.ok) {
            let result = await response.json();
            if (result.isSuccess) {
                return result; // Newly created document
            } else {
                return { errors : result.errors };
            }
        } else {
            // Error return from Azure Fucntion
            let errorResponse = await response.json();
            return { errors : 'Connection failed to API. Error :' + errorResponse.Message};
        }
    }

    public async Update(_keyValues: any) {
        let accountInfo = await authProvider.getAccountInfo();

        let API_URL = 'https://ultimatesprodevapilx01.azurewebsites.net/api';
        let API_ENDPOINT = '/GeneralColSet?code=F6RR4kmZpCcCsdjwQcIaeV8sYhnAschjLDm55a0BRBDa6XCZCoEo6A==';
        let API = API_URL + API_ENDPOINT;
        let response = await fetch(API,
            {
                method: "post",
                headers: new Headers({
                    "Authorization": "Bearer " + accountInfo?.jwtIdToken,
                    "Content-Type": "application/json"
                }),
                body: JSON.stringify(_keyValues)
            }
        );

        if (response.ok) {
            let result = await response.json();
            if (result.isSuccess) {
                return result; // Updated document
            } else {
                return { errors : result.errors, isConflict : result.isConflict };
            }
        } else {
            // Error return from Azure Fucntion
            let errorResponse = await response.json();
            return { errors : 'Connection failed to API. Error :' + errorResponse.Message};
        }
    }

    public async Delete(_id: string, table:string) {
        let accountInfo = await authProvider.getAccountInfo();
        
        let _doc : any = {};
        _doc.id = _id;
        _doc.table = table;

        let API_URL = 'https://ultimatesprodevapilx01.azurewebsites.net/api';
        let API_ENDPOINT = '/GeneralColDelete?code=ELVlgEreepMlsRS/DwrgIn3bBjPpGupow3Wfunabj1R8N86SRrRByA==';
        let API = API_URL + API_ENDPOINT;
        let response = await fetch(API,
            {
                method: "post",
                headers: new Headers({
                    "Authorization": "Bearer " + accountInfo?.jwtIdToken,
                    "Content-Type": "application/json"
                }),
                body: JSON.stringify(_doc)
            }
        );

        if (response.ok) {
            let result = await response.json();
            if (result.isSuccess) {
                return result; // Updated document
            } else {
                return { errors : result.errors };
            }
        } else {
            // Error return from Azure Fucntion
            let errorResponse = await response.json();
            return { errors : 'Connection failed to API. Error :' + errorResponse.Message};
        }
    }

    public async GetLatestPmtNumber() {
        let accountInfo = await authProvider.getAccountInfo();

        let API_URL = 'https://ultimatesprodevapilx01.azurewebsites.net/api';
        let API_ENDPOINT = '/GetLatestPmtRunningNo?code=0RaXql6nBQdK9Tqp4yGlpPdoHtcxsfQHgcukPMSl3IXPojtpxbmS5A==';
        let API = API_URL + API_ENDPOINT;

        let response = await fetch(API,
            {
                method: "get",
                headers: new Headers({
                    "Authorization": "Bearer " + accountInfo?.jwtIdToken,
                    "Content-Type": "application/json"
                })
            }
        );
        if (response.ok) {
            let result = await response.json();
            if (result.isSuccess) {
                return result;
            } else {
                return { errors : result.errors };
            }
        } else {
            return { errors : 'Connection failed to API' };
        }
    }

    public async GetLatestOrderNumber() {
        let accountInfo = await authProvider.getAccountInfo();

        let API_URL = 'https://ultimatesprodevapilx01.azurewebsites.net/api';
        let API_ENDPOINT = '/GetLatestOrderRunningNo?code=jPnqXIL8zgk7J12WK3nhXsyzEu/LTjw0fC0dv7acys3dj/ybtaGfag==';
        let API = API_URL + API_ENDPOINT;

        let response = await fetch(API,
            {
                method: "get",
                headers: new Headers({
                    "Authorization": "Bearer " + accountInfo?.jwtIdToken,
                    "Content-Type": "application/json"
                })
            }
        );
        if (response.ok) {
            let result = await response.json();
            if (result.isSuccess) {
                return result;
            } else {
                return { errors : result.errors };
            }
        } else {
            return { errors : 'Connection failed to API' };
        }
    }

    
    public async SubscribeValidation(_doc:any) {
        let accountInfo = await authProvider.getAccountInfo();

        let API_URL = 'https://ultimatesprodevapilx01.azurewebsites.net/api';
        let API_ENDPOINT = '/SubscribeValidation?code=Im7wQ/Wa2wCwiI1kSAW53Pc9MMUgO4NTo5v6Y1XpSPJv90pyhDvfWQ==';
        let API = API_URL + API_ENDPOINT;

        let response = await fetch(API,
            {
                method: "post",
                headers: new Headers({
                    "Authorization": "Bearer " + accountInfo?.jwtIdToken,
                    "Content-Type": "application/json"
                }),
                body: JSON.stringify(_doc)
            }
        );
        if (response.ok) {
            let result = await response.json();
            if (result.isSuccess) {
                return result;
            } else {
                return { errors : result.errors };
            }
        } else {
            return { errors : 'Connection failed to API' };
        }
    }

    public async PrePaymentProcess(_doc:any) {
        let accountInfo = await authProvider.getAccountInfo();

        let API_URL = 'https://ultimatesprodevapilx01.azurewebsites.net/api';
        let API_ENDPOINT = '/PaymentRequest?code=LEXx0p8fXDaqns5VNJSqCNJzi0xVYLcYUlYA1zWDfDfZe/ZBnN8tSA==';
        let API = API_URL + API_ENDPOINT;

        let response = await fetch(API,
            {
                method: "post",
                headers: new Headers({
                    "Authorization": "Bearer " + accountInfo?.jwtIdToken,
                    "Content-Type": "application/json"
                }),
                body: JSON.stringify(_doc)
            }
        );
        if (response.ok) {
            let result = await response.json();
            if (result.isSuccess) {
                return result;
            } else {
                return { errors : result.errors };
            }
        } else {
            return { errors : 'Connection failed to API' };
        }
    }

    public async OrderRequest(_doc:any) {
        let accountInfo = await authProvider.getAccountInfo();

        let API_URL = 'https://ultimatesprodevapilx01.azurewebsites.net/api';
        let API_ENDPOINT = '/OrderRequest?code=GrH2FxW1UEHSc8udnmdvzrGxleGmHTMJhO3GfvIfMntVAzFuENxwKQ==';
        let API = API_URL + API_ENDPOINT;

        let response = await fetch(API,
            {
                method: "post",
                headers: new Headers({
                    "Authorization": "Bearer " + accountInfo?.jwtIdToken,
                    "Content-Type": "application/json"
                }),
                body: JSON.stringify(_doc)
            }
        );
        if (response.ok) {
            let result = await response.json();
            if (result.isSuccess) {
                return result;
            } else {
                return { errors : result.errors };
            }
        } else {
            return { errors : 'Connection failed to API' };
        }
    }

    public async ReadOrderByOrderNo(orderNo:string) {
        let accountInfo = await authProvider.getAccountInfo();

        let API_URL = 'https://ultimatesprodevapilx01.azurewebsites.net/api';
        let API_ENDPOINT = '/GetDocByOrderNo?code=ZJfcA/E4r9OQtlq1QraHBbZllfvlzKrmTp7J1X/9qBxCtuzxYLeDtw==';
        let API_PARAM = '&orderNo=' + orderNo;
        let API = API_URL + API_ENDPOINT + API_PARAM;

        let response = await fetch(API,
            {
                method: "get",
                headers: new Headers({
                    "Authorization": "Bearer " + accountInfo?.jwtIdToken,
                    "Content-Type": "application/json"
                })
            }
        );
        if (response.ok) {
            let result = await response.json();
            if (result.isSuccess) {
                return result;
            } else {
                return { errors : result.errors };
            }
        } else {
            return { errors : 'Connection failed to API' };
        }
    }
}